import React, { useContext } from "react";
import { FaBolt, FaTools, FaExclamationTriangle, FaUserShield } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import "../TrainingGlobal.css";
import BannerImage from "./elect.jpg";

const Electrical: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleBooking = () => {
    if (isAuthenticated) {
      navigate('/booking/electrical');
    } else {
      navigate('/login', { state: { from: '/booking/electrical' } });
    }
  };

  return (
    <div className="training-page">
      <div className="training-max-width">

        {/* --- HERO --- */}
        <div className="training-hero" style={{ backgroundImage: `url(${BannerImage})` }}>
          <span className="hero-tag">High Voltage</span>
          <h1 className="hero-title">Electrical Safety</h1>
          <p className="hero-subtitle">
            Respect the power. Understanding circuits, grounding, and the life-saving importance of LOTO.
          </p>
          <button onClick={handleBooking} className="btn-hero">
            Book Now <span style={{ fontSize: '1.2em' }}>→</span>
          </button>
        </div>

        {/* --- CONTENT --- */}
        <div className="detail-content">

          <div className="content-article">
            <div className="article-section">
              <h2 className="article-heading">The Fundamentals</h2>
              <p className="article-text">
                Electricity seeks the path of least resistance to the ground. If you are part of that path,
                you will be shocked.
                <br /><strong>Voltage:</strong> The pressure pushing electrons (V).
                <br /><strong>Current:</strong> The flow of electrons (Amps) - <em>This is what kills.</em>
                <br /><strong>Resistance:</strong> Opposition to flow (Ohms).
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">LOTO (Lockout / Tagout)</h2>
              <p className="article-text">
                The golden rule of electrical maintenance: <strong>De-energize, Verify, Lock.</strong>
                Never work on live circuits unless absolutely necessary and authorized. A tag is just a warning;
                a lock is a physical barrier.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Arc Flash Hazards</h2>
              <p className="article-text">
                An arc flash is a violent electrical explosion that can reach 35,000°F (4x hotter than the sun).
                Wear appropriate arc-rated PPE (FR clothing, face shields) when working near high-energy equipment.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Inspection & Tools</h2>
              <p className="article-text">
                Inspect cords for fraying. Use double-insulated tools. check GFCIs regularly.
                Never bypass a breaker or fuse—it tripped for a reason.
              </p>
            </div>
          </div>

          {/* --- SIDEBAR --- */}
          <div className="content-sidebar">
            <div className="sidebar-widget">
              <h4 className="widget-title">Rules to Live By</h4>
              <ul className="key-list">
                <li><FaBolt className="check-icon" /> Test Before Touch</li>
                <li><FaTools className="check-icon" /> Insulated Tools Only</li>
                <li><FaExclamationTriangle className="check-icon" /> Mind the Gap (Arc)</li>
                <li><FaUserShield className="check-icon" /> Wear Rubber Gloves</li>
              </ul>
            </div>

            <div className="sidebar-widget" style={{ background: 'linear-gradient(135deg, #111 0%, #222 100%)', border: '1px solid #333' }}>
              <h4 className="widget-title">Zero Incidents</h4>
              <p style={{ color: '#ccc', marginBottom: '20px', fontSize: '0.9rem' }}>
                Electrical safety is non-negotiable. Get trained.
              </p>

              <button
                onClick={handleBooking}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Book Now
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Electrical;
